<template>
  <div

    class="card"
  >
    <div
      v-if="order"
      class="card-header"
    >
      <h2>{{ $t('orders.order') }} № {{ order.long_id }}</h2>
    </div>
    <div
      v-if="order"
      class="card-body"
    >
      <div class="row">
        <p class="col-md-4">
          {{ `${$t('orders.status')}: ${$l(order.status.title)}` }}
        </p>
        <p class="col-md-4">
          {{ `${$t('returns.seller')}: ${$l(order.company.title)}` }}
        </p>
      </div>
      <div class="row">
        <p class="col-md-4">
          {{ $t('orders.delivery') }}: {{ order.delivery_cost | money }}
        </p>
        <p class="col-md-4">
          {{ `${$t('orders.customer')}: ${order.buyer.name }` }}
        </p>
      </div>
      <hr>
      <div class="mt-10 mb-10">
        <a-form-model-item :label="$t('returns.select_products')">
          <a-list
            item-layout="vertical"
            size="large"
            :data-source="productList"
          >
            <a-list-item
              slot="renderItem"
              key="item.id"
              slot-scope="item, index"
            >
              <a-list-item-meta :description="$options.filters.money(item.price_per_item)">
                <a-checkbox
                  slot="title"
                  v-model="item.checked"
                >
                  {{ $l(item.title) }}
                </a-checkbox>
                <!-- <ImageView slot="avatar" :image="item.images[0]" :width="60" :height="60"/> -->
              </a-list-item-meta>
              <transition name="slide-fade">
                <div
                  v-if="item.checked"
                  class="return-options"
                >
                  <a-form-model-item
                    class="mb-0"
                    :label="$t('common.quantity')"
                    :label-col="{ span: 3 }"
                    label-align="left"
                  >
                    <a-button
                      size="small"
                      :disabled="item.returnCount <= 1"
                      @click="subtract(index)"
                    >
                      <a-icon type="minus" />
                    </a-button>
                    <span class="p-2">{{ item.returnCount }}</span>
                    <a-button
                      size="small"
                      :disabled="item.returnCount >= item.count"
                      @click="add(index)"
                    >
                      <a-icon type="plus" />
                    </a-button>
                  </a-form-model-item>
                  <a-form-model-item
                    class="mb-0"
                    :label="$t('returns.reason')"
                    :label-col="{ span: 3 }"
                    label-align="left"
                  >
                    <a-radio-group
                      v-model="item.reason"
                      class="reason-selector"
                      button-style="solid"
                    >
                      <a-radio
                        :value="'DAMAGED'"
                        class="reason-item mb-2"
                      >
                        {{ $t('returns.damaged_product') }}
                      </a-radio>
                      <a-radio
                        :value="'WRONG'"
                        class="reason-item mb-2"
                      >
                        {{ $t('returns.wrong_product') }}
                      </a-radio>
                      <a-radio
                        :value="'OTHER'"
                        class="reason-item"
                      >
                        {{ $t('returns.other_reason') }}
                      </a-radio>
                    </a-radio-group>
                    <transition name="slide-fade">
                      <a-textarea
                        v-if="item.reason === 'OTHER'"
                        v-model="item.reasonDescription"
                        class="mt-2"
                        :rows="2"
                        :placeholder="$t('orders.notes.note')"
                      />
                    </transition>
                  </a-form-model-item>
                </div>
              </transition>
            </a-list-item>
          </a-list>
        </a-form-model-item>
      </div>
      <a-button
        :loading="showLoading"
        :disabled="!isFormValid"
        type="primary"
        size="large"
        @click="sendReturn"
      >
        {{ $t('common.send') }}
      </a-button>
      <a-modal
        :visible="previewVisible"
        :footer="null"
        @cancel="handleCancel"
      >
        <img
          alt="decline-image"
          style="width: 100%"
          :src="previewImage"
        >
      </a-modal>
    </div>
    <a-skeleton
      v-else
      class="p-3"
      active
      :paragraph="{rows: 10}"
    />
  </div>
</template>
<script>
import { getBase64 } from '@/utils/fileUtils'

import orderService from '@/services/api/admin/stores/order-service'

export default {
  name: 'AdminReturnApplication',
  components: {
  },
  data() {
    return {
      orderId: this.$route.params.id,
      order: null,
      productList: [],
      selectedProducts: [],
      showLoading: false,
      images: [],
      previewImage: '',
      previewVisible: false,
    }
  },

  computed: {
    rowSelection () {
      return {
        onChange: (_, selectedRows) => {
          this.selectedProducts = selectedRows.map(row => row.id)
        },
      }
    },

    productsToReturn () {
      const res = this.productList
        .filter(product => product.checked)
        .map(({ returnCount, reason, reasonDescription, orderItemHashId }) => ({ returnCount, id: orderItemHashId, reason, reasonDescription }))
      return res
    },

    isFormValid () {
      const itemsValid = this.productsToReturn.length > 0 &&
        this.productsToReturn.reduce((res, item) => {
          return (res &&
            (item.reason === 'DAMAGED' || item.reason === 'WRONG' ||
            (item.reason === 'OTHER' && item.reasonDescription.length > 0))
          )
        }, true)
      return itemsValid
    },
  },

  watch: {
    order: {
      handler (newVal) {
        this.productList = newVal.detailed_items.map((item) => {
          return {
            ...item,
            returnCount: 1,
            reason: null,
            reasonDescription: '',
            checked: false,
          }
        })
      },
    },
  },

  mounted() {
    this.fetchOrderInfo()
  },

  methods: {
    async fetchOrderInfo () {
      try {
        const { data: { content } } = await orderService.getOrder(this.orderId)
        this.order = content
      } catch (error) {
        console.log(error)
      } finally {
      }
    },

    async handlePreview(file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },

    handleCancel() {
      this.previewVisible = false
    },

    handleChange ({ fileList }) {
      this.images = fileList
    },

    async sendReturn () {
      this.showLoading = true
      const orderId = this.order.long_id
      const payload = this.productsToReturn
      try {
        const res = await orderService.createAdminReturnApplication(orderId, payload)
        this.$router.push(`/admin/seller/returns/${res.data.content.hash_id}`)
      } catch (error) {
        console.log(error)
      } finally {
        this.showLoading = false
      }
    },

    subtract (index) {
      this.productList[index].returnCount--
    },

    add (index) {
      this.productList[index].returnCount++
    },
  },
}
</script>

<style lang="scss" scoped>
  .reason-selector {
    .reason-item {
      font-weight: normal !important;
    }

  }

  .slide-fade-enter-active {
    transition: all .2s ease;
  }
  .slide-fade-leave-active {
    transition: all .2s ease;
  }
  .slide-fade-enter,
  .slide-fade-leave-to {
    opacity: 0;
  }

  .card {
    max-width: 64em;
  }

</style>
